import type { BillingAddress } from '@/components/PaymentMethods/CreditCardSchema'
import type { ChargebeeCardComponent } from '@/global'
import type { Token } from '@/hooks/usePaymentMethods'
import type { User } from '@/types/User'

export type PaymentError = { error: string }
type Result = Token | PaymentError

const getTokenForCreditCard = async (
  cardRef: React.RefObject<ChargebeeCardComponent>,
  currentUser: User,
  billingAddress: BillingAddress
): Promise<Result> => {
  if (!cardRef.current) {
    return {
      error:
        'Sorry, there was an issue validating credit card with our processor.',
    }
  }

  const additionalData = {
    ...billingAddress,
    zip: billingAddress.postalCode,
    email: currentUser.email,
  }
  const tokenData = await cardRef.current.tokenize(additionalData)
  if (!tokenData.token) {
    return {
      error:
        'Sorry, there was an issue validating credit card with our processor.',
    }
  }

  return {
    token: tokenData.token,
  }
}

export { getTokenForCreditCard }
